function Ceiling() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width="100%"
      height="100%"
    >
      <g
        fill="none"
        stroke="#CF9857"
        stroke-linecap="butt"
        stroke-linejoin="miter"
      >
        <line x1="20" y1="190" x2="435" y2="250" stroke-width="14" />
        <line x1="102" y1="165" x2="475" y2="218" stroke-width="14" />
        <line
          x1="184"
          y1="140"
          x2="437"
          y2="176"
          stroke-width="14"
          stroke-linecap="square"
        />

        <line x1="228" y1="110" x2="57" y2="255" stroke-width="14" />
        <line x1="304" y1="130" x2="133" y2="275" stroke-width="14" />
        <line x1="380" y1="150" x2="209" y2="295" stroke-width="14" />
        <line x1="456" y1="170" x2="330" y2="280" stroke-width="14" />

        <path
          d="M 57,255 L 330,280 L 330,435"
          stroke-width="16"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
      </g>
    </svg>
  );
}

export default Ceiling;
